<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
export default {
  name: 'App',
}
</script>

<style>
	@import './assets/css/iconfont/iconfont.css';
  	@import './assets/css/base.css';
  	@import './assets/css/common.css';
  	#nprogress .bar {
      background: #00946e !important; 
    }
</style>



// WEBPACK FOOTER //
// src/App.vue